import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "leading-4" }
const _hoisted_2 = {
  style: {"min-width":"40px","display":"inline-block"},
  class: "text-buffy-100 select-none text-xs"
}

import { JobLog, Level } from '../joblog_pb';
import { PropType, computed } from 'vue';
import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb';

export default /*@__PURE__*/_defineComponent({
  __name: 'EntryLine',
  props: {
    index: {
        type: Number
    },
    source: {
        type: Object as PropType<{ message: string, timestamp: Timestamp, level: any, id: string }>,
        default() {
            return {}
        }
    }

},
  setup(__props) {

const props = __props;
const messageClass = computed(() => {
    switch (props.source.level) {
        case Level.WARN: return "text-nosferatu-500";
        case Level.DEBUG: return "text-nosferatu-300";
        case Level.INFO: return "text-nosferatu-50";
        case Level.WARN: return "text-morbius-600";
        case Level.ERROR: return "text-marcelin-400";
        case Level.FATAL: return "text-marcelin-800";
    }
});

const prompt = computed(() => {
    //return props.source.id;
    if (props.source.timestamp.getSeconds() != -1) {
        return props.source.timestamp.toDate().toLocaleString();
    } else {
        return "(s) " + new Date(parseInt(props.source.id.split("-")[0], 10)).toLocaleString();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(prompt.value), 1 /* TEXT */),
    _createElementVNode("pre", {
      class: _normalizeClass([messageClass.value, 'inline'])
    }, " " + _toDisplayString(__props.source.message), 3 /* TEXT, CLASS */)
  ]))
}
}

})